module.exports = __webpack_public_path__ + "img/164.13c876a2.jpg";